import React, { FC, useState } from 'react'
import { eye } from '../../assets/images/images'
import ModalContainer from '../Modal/ModalContainer'
import DocumentPreviewModalContent from './DocumentPreviewContent'

const MultiFilePreview: FC<{ content: string }> = ({ content }) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  return (
    <>
      <button
        type="button"
        onClick={() => openModal()}
        className="pointer dInlineBlock px0 btnUnstyled"
      >
        <img className="mr1 textBlue" height="14" alt="preview" src={eye} />
      </button>
      <ModalContainer isOpen={isModalOpen}>
        <DocumentPreviewModalContent file={content} onClose={closeModal} />
      </ModalContainer>
    </>
  )
}

export default MultiFilePreview
